import { __assign, __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import { getGallectionById } from '../selectors';
import { normalizeGallection } from '../../redux/normalizr/helpers';
function setGallectionPrice(action) {
    var _a, folderId, pointsPrice, gallection, updatedGallection, entities;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, folderId = _a.folderId, pointsPrice = _a.pointsPrice;
                return [4 /*yield*/, select(getGallectionById, folderId)];
            case 1:
                gallection = _b.sent();
                if (!gallection) {
                    return [2 /*return*/];
                }
                updatedGallection = __assign(__assign({}, gallection), { premiumFolderData: __assign(__assign({ type: 'paid', hasAccess: true }, gallection.premiumFolderData), { pointsPrice: pointsPrice }) });
                entities = normalizeGallection(updatedGallection);
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default setGallectionPrice;
//# sourceMappingURL=setGallectionPrice.js.map